import React, { useContext, useState } from 'react'

import { Carousel, message } from 'antd'

import { CreateAudienceDataContext } from '../../../helpers/Context';
import MarketingAudienceTopCard from './MarketingAudienceTopCard';
import { rangeLastMonth, rangeYesterday} from '../../../helpers/DateUtils';


export default function MarketingAudienceTopCarousel({ form }) {
   
   const {
      audienceGeneralInfoForm,
      resetFormValues,
      setFormChanged,
      formChanged,
   } = useContext(CreateAudienceDataContext)
   
   const onClick = (e) => {

      try {
         message.loading();
         resetFormValues();
         setTimeout(() => {
            message.destroy()
            form.setFieldsValue(e.filters)
            audienceGeneralInfoForm.setFieldsValue({ "audienceName": e.title });
            audienceGeneralInfoForm.setFieldsValue({ "audienceDescription": e.description });
            message.success(`Filtro "${e.title}" attivato`)
            form.validateFields()
            setFormChanged(formChanged + 1)
         }, 500);
      } catch (error) {
         message.error(error)
      }
   };

   const dummyTop = [
      {
         "title": "Compleanni Oggi",
         "description": "Seleziona tutti gli utenti che oggi fanno il compleanno.",
         "filters": {
            birthday_list:[
               {
                  "value": "today",
               },
            ]
         }
      },
      {
         "title": "Compleanni nel Mese",
         "description": "Seleziona tutti gli utenti che compiono il compleanno questo mese",
         "filters": {
            birthday_list:[
               {
                  "value": "month",
               },
            ]
         }
      },
      {
         "title": "Utenti iscritti ieri",
         "description": "Individua tutti gli utenti che si sono anagrafati ieri",
         "filters": {
            activation_dates_list: [
               {
                  "full_date": rangeYesterday,
                  "day_type": "now",
                  "day_offset": "-30",
                  "date_condition": "over",
                  "update_automatically":true
               }
            ],
         }
      },
      {
         "title": "Utenti dell'ultimo mese",
         "description": "Individua tutti gli utenti attivati nell'ultimo mese",
         "filters": {
            activation_dates_list: [
               {
                  "full_date": rangeLastMonth,
                  "day_type": "now",
                  "day_offset": "-30",
                  "date_condition": "over",
                  "update_automatically":true
               }
            ],
         }
      },
   ]


  return (
     <Carousel
        className='di-marketing-audience-top'
        // ----------- regole di responsive per le slide del carosello -----------
        responsive={[
           {
              breakpoint: 5000, 
              settings: {
                 slidesToShow: 6, 
                 slidesToScroll: 1,
                 dots: true,
              },
           },
           {
              breakpoint: 2500, 
              settings: {
                 slidesToShow: 5, 
                 slidesToScroll: 1,
                 dots: true,
              },
           },
           {
              breakpoint: 1500, 
              settings: {
                 slidesToShow: 4, 
                 slidesToScroll: 1,
                 dots: true,
              },
           },
           {
              breakpoint: 1024, 
              settings: {
                 slidesToShow: 3, 
                 slidesToScroll: 1,
                 dots: true,
              },
           },
           {
              breakpoint: 800, 
              settings: {
                 slidesToShow: 2, 
                 slidesToScroll: 1,
              },
           },
           {
              breakpoint: 550, 
              settings: {
                 slidesToShow: 1, 
                 slidesToScroll: 1,
              },
           },
        ]}
        // ----------- regole di responsive per le slide del carosello -----------
        arrows
        infinite={false}
     >
         {dummyTop.map((content, index) => { //ciclo che prende le slide e i singoli pubblici
            return (
               <div key={index}>
                  <MarketingAudienceTopCard topAudienceData={content} onClick={onClick}/>
               </div>
            )
         })}
   </Carousel>
  )
}
